import useClientContext from "../../../../context/useClientContext";

// Must match SmartViewArtifactAccess.CanManage in the BI Engine.
const useCanManageArtifacts = (): boolean => {
  const { hasPermissions, isAllowedToAccessAllEntities } = useClientContext();
  return hasPermissions(["ManageDashboards", "ManageReports"]) && isAllowedToAccessAllEntities;
};

export default useCanManageArtifacts;
